/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PostCategoryResponse } from '../../models/post-category-response';

export interface GetAvailableCategories$Params {
}

export function getAvailableCategories(http: HttpClient, rootUrl: string, params?: GetAvailableCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PostCategoryResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAvailableCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PostCategoryResponse>>;
    })
  );
}

getAvailableCategories.PATH = '/api/available-categories';
